import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';;
import Header from '../../../components/Header';
import Barra from '../../../components/barra';
import MenuFacturacion from '../../../components/hacienda/facturacion/MenuFacturacion';
import TablaUsuarioFacturacion from '../../../components/hacienda/facturacion/tablaUsuariosFacturacion';


function UsuariosFacturacion() {

  const { user } = useContext(AuthContext);
  let op = require('../../../../src/modulos/datos');

  return (

    user && (

      <div style={{ height: "100vh", padding: 0 }}>
        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
          <Header />
        </div>
        <div className="row col-md-12" style={{ height: "90%", padding: 0, margin: 0 }}>
          <Barra />
          <div className="col-md-10" style={{ height: "100%", padding: 0 }}>
            <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
              <MenuFacturacion />
            </div>
            <div className="col-md-12" style={{ height: "90%", padding: 0 }}>
              <TablaUsuarioFacturacion />
            </div>
          </div>
        </div>
      </div>

    )


  );
}


export default UsuariosFacturacion;
